module.exports = __webpack_public_path__ + "img/45.35195689.jpeg";